/**
 * Copyright © schukai GmbH and all contributing authors, {{copyRightYear}}. All rights reserved.
 * Node module: @schukai/monster
 *
 * This source code is licensed under the GNU Affero General Public License version 3 (AGPLv3).
 * The full text of the license can be found at: https://www.gnu.org/licenses/agpl-3.0.en.html
 *
 * For those who do not wish to adhere to the AGPLv3, a commercial license is available.
 * Acquiring a commercial license allows you to use this software without complying with the AGPLv3 terms.
 * For more information about purchasing a commercial license, please contact schukai GmbH.
 */

import {Popper as NewPopper} from "../layout/popper.mjs";

export {Popper};

/**
 * @since 1.10.0
 * @copyright schukai GmbH
 * @deprecated since 3.66.0 use {@link Monster.Components.Layout.Popper}
 */
class Popper extends NewPopper {

}